import { render, staticRenderFns } from "./ItemOrderControl.vue?vue&type=template&id=658ec448&scoped=true&"
import script from "./ItemOrderControl.vue?vue&type=script&lang=js&"
export * from "./ItemOrderControl.vue?vue&type=script&lang=js&"
import style0 from "./ItemOrderControl.vue?vue&type=style&index=0&id=658ec448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ec448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('658ec448', component.options)
    } else {
      api.reload('658ec448', component.options)
    }
    module.hot.accept("./ItemOrderControl.vue?vue&type=template&id=658ec448&scoped=true&", function () {
      api.rerender('658ec448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/Toolbar/ItemOrderControl.vue"
export default component.exports